import type { Columns, Filters } from '@/types/table';

export const PROPERTY_ERROR_COLUMNS: Columns[] = [
  {
    name: 'Property type',
    selector: 'propertyType',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Apt/Suite/Other',
    selector: 'unitNumber',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Address',
    selector: 'address',
    width: '300px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'City',
    selector: 'city',
    width: '220px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'State',
    selector: 'state',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Zip Code',
    selector: 'zipCode',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Property ID',
    selector: 'propertyId',
    width: '240px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Bedrooms',
    selector: 'bedrooms',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Bathrooms',
    selector: 'bathrooms',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Square Feet',
    selector: 'squareFeet',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Unit ID',
    selector: 'unitId',
    width: '240px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Portfolio',
    selector: 'portfolioName',
    width: '260px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Unit Status',
    selector: 'propertyStatus',
    width: '240px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Rent Ready',
    selector: 'rentReady',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Listing Date',
    selector: 'listingDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Is Listed',
    selector: 'isListed',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Days on Market',
    selector: 'daysOnMarket',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Available Date',
    selector: 'availableDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Lease Signed Date',
    selector: 'leaseSignedDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Lease Start Date',
    selector: 'leaseStartDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Lease End Date',
    selector: 'leaseEndDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Move In Date',
    selector: 'moveInDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Notice Given Date',
    selector: 'noticeGivenDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Move Out Date',
    selector: 'moveOutDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Assignee',
    selector: 'assignee',
    width: '240px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Is Active',
    selector: 'isActive',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Entity ID',
    selector: 'entity',
    width: '260px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
];

export const ERROR_TABLE_FILTERS: Filters[] = [
  { selector: 'address', value: '' },
  { selector: 'city', value: '' },
  { selector: 'state', value: '' },
  { selector: 'zipCode', value: '' },
];
